{
  "carrierLabel": "承运公司",
  "searchPlaceholder": "按名称搜索",
  "selectAsCarrier": "选择“{name}”作为承运商",
  "typeToSearch": "输入以搜索公司"
}
